export default __webpack_public_path__ + "static/media/summary2.ad0a20a5.svg";